<template>
  <aside class="w-64 bg-gray-50 border-r border-gray-200 h-full">
    <nav class="p-4">
      <ul class="space-y-2">
        <li v-for="item in menuItems" :key="item.id">
          <button
            @click="$emit('section-change', item.id)"
            :class="[
              'w-full px-4 py-3 rounded-lg text-center transition-colors',
              activeSection === item.id
                ? 'bg-blue-50 text-blue-600'
                : 'text-gray-700 hover:bg-gray-100'
            ]"
          >
            <div class="flex items-center justify-center relative">
              <span>{{ item.label }}</span>
              <el-badge
                v-if="item.badge && item.badge > 0"
                :value="item.badge"
                class="absolute -top-1 -right-2"
                type="danger"
              />
            </div>
          </button>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script setup>
import { computed } from 'vue'
import { useAppStore } from '@/stores'
import { storeToRefs } from 'pinia'

defineProps({
  activeSection: {
    type: String,
    required: true
  }
})

defineEmits(['section-change'])

const store = useAppStore()
const { pendingFeedbackCount } = storeToRefs(store)

const menuItems = computed(() => {
  const items = [
    { id: 'report', label: '填报信息', moduleName: '填报信息' },
    { id: 'achievements', label: '我的成果', moduleName: '我的成果' },
    { id: 'profile', label: '个人信息', moduleName: '个人信息' },
    { id: 'department', label: '教研室管理', moduleName: '教研室管理' },
    { id: 'teacher-status', label: '教师状态维护', moduleName: '教师状态维护', badge: pendingFeedbackCount.value },
    { id: 'info-overview', label: '信息总览', moduleName: '信息总览' }
  ]
  const filtered = items.filter(i => store.hasModuleByName(i.moduleName))
  if (store.isAdmin()) filtered.push({ id: 'permission-settings', label: '权限设置' })
  return filtered
})
</script>

<style scoped>
.badge-red {
  @apply bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5 min-w-[1.25rem] h-5 flex items-center justify-center;
}
</style>
